import { RouteItem } from "@/javascript/domain/entities/maps/route-item"
import { RouteMember } from "@/javascript/domain/entities/maps/route-member"
import { ListMapper } from "./mapper"
import { RemoteRouteItem } from "@/javascript/data/entities"

export class RouteMapper extends ListMapper<RouteItem, RemoteRouteItem> {
  constructor(
    private readonly routeMemberMapper: ListMapper<RouteMember>
  ) { super() }

  toEntity (data: RemoteRouteItem): RouteItem {
    return {
      id: data.id,
      date: data.date,
      createdAt: data.created_at,
      updatedAt: data.updated_at,
      members: this.routeMemberMapper.toEntityList(data.members)
    }
  }
}
